import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useAuth } from '../../../../../hooks/useAuth';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const DocumentDialog = ({ open, handleClose, document }) => {
  const [pdf, setPdf] = useState();
  const { accessToken } = useAuth();

  const onDocumentLoadSuccess = pdf => {
    setPdf(pdf);
  };

  const file = document?.isProtected
    ? document?.protectedUrl
    : document?.publicUrl;

  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle>{document?.displayName}</DialogTitle>
      <DialogContent className={classes.document}>
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          loading="A PDF betöltése..."
          noData="A PDF nem található."
          error="Nem sikerült betölteni a PDF fájlt."
          options={{
            ...(document?.isProtected && {
              httpHeaders: {
                authorization: accessToken ? `Bearer ${accessToken}` : '',
              },
            }),
          }}
        >
          {Array.from(Array(pdf?.numPages), (e, i) => (
            <Page
              pageIndex={i}
              scale={1.2}
              loading="Az oldal betöltése..."
              noData="Az oldal nem található."
              error="Nem sikerült betölteni az oldalt."
              className={classes.page}
            />
          ))}
        </Document>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Bezárás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles(() => ({
  document: {
    textAlign: 'center',
    color: 'white',
    backgroundColor: '#333333',
  },
  page: {
    borderTop: '5px solid #333333',
    borderBottom: '5px solid #333333',
    '& canvas': {
      margin: 'auto',
    },
  },
}));

export default DocumentDialog;
